import React, { useCallback, useState } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, useGetSchema, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { SupplierService } from '../types';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const SupplierServiceProvider: React.FC<Props> = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState<Array<SupplierService>>([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState<SupplierService | {}>({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError) as (
        id: string,
        params?: Partial<SupplierService>
    ) => Promise<SupplierService>;

    const handleGetData = useCallback((res: SupplierService[]): SupplierService[] => {
        setData(res);
        return res;
    }, []);

    const get = useGet(api, data, handleGetData, setError);

    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const handleSetData = useCallback((_item: SupplierService, newData: SupplierService[]) => {
        setData(newData);
    }, []);

    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((_id: string, newData: SupplierService[]) => {
        setData(newData);
        setSelected({});
        return _id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default SupplierServiceProvider;
